import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { ErrorFallback } from "@components/ui/error-fallback";
import { isChunkLoadError } from "@app/router/import-or-reload";

export function RootErrorBoundary() {
  const error = useRouteError();

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : String(error);

  const isChunkError = isChunkLoadError(error);

  return (
    <div className="flex min-h-screen w-full items-center justify-center p-4">
      <ErrorFallback
        error={error instanceof Error ? error : new Error(message)}
        reset={() => window.location.reload()}
        title={isChunkError ? "Couldn't load this page" : "Something went wrong"}
        description={
          isChunkError
            ? "This can happen after an update. Reload to get the latest version."
            : "An error occurred while loading this page. Reload to try again."
        }
      />
    </div>
  );
}
